import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en';
import { frCA } from './fr-CA';

export const knbrOrderToolsTranslations: TranslationResources = { en, fr_CA: frCA };

export const knbrOrderToolsTranslationChunksConfig: TranslationChunksConfig = {
  knbrOrderTools: ['quickOrder', 'quickEntry', 'orderForms', 'orderImport', 'knbrOrderDetails', 'replacementProduct'],
};
